// ThemeContext.js
import React, { createContext, useContext, useState } from 'react';

// Define your theme properties
const themes = {
  light: {
    background: '#ffffff',
    color: '#000000',
    primary: '#5aaafa'
  },
  dark: {
    background: '#000000',
    color: '#ffffff',
    primary: '#5aaafa'

  },
};

// Create a Theme Context
const ThemeContext = createContext({});

// Create a Theme Provider component
export const ThemeProvider = ({ children }: any) => {
  const [theme, setTheme] = useState(themes.light); // Default theme

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === themes.light ? themes.light : themes.light));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => {
  return useContext(ThemeContext);
};